import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import {
  ISoftValidationModalPayloadData,
  isSoftValidationBulkErrorResponse,
  isSoftValidationSingleErrorResponse,
  SINGLE_KEY,
} from "@ryde/shared";

import { SoftValidationErrorList } from "./soft-validation.error-list";
import {
  SoftValidationListStyled,
  SoftValidationWrapperStyled,
} from "./soft-validation.styled";

export const SoftValidationContent: FC<{
  data: ISoftValidationModalPayloadData;
}> = ({ data }) => {
  const { t } = useTranslation();
  let content: ReactNode = "";

  if (isSoftValidationBulkErrorResponse(data)) {
    const isSingleError = data.items.length === 1;

    if (isSingleError) {
      content = (
        <SoftValidationErrorList
          entity={data.items[0].entity}
          errors={data.items[0].validationErrors}
        />
      );
    } else {
      content = data.items.map((item, index) => {
        return (
          <li key={index}>
            <span>
              {t(`${item.entity}.${SINGLE_KEY}`)} {t("ride.formLabel.id")}{" "}
              {item.itemId}
            </span>
            <SoftValidationListStyled>
              <SoftValidationErrorList
                entity={item.entity}
                errors={item.validationErrors}
              />
            </SoftValidationListStyled>
          </li>
        );
      });
    }
  } else if (isSoftValidationSingleErrorResponse(data)) {
    content = (
      <SoftValidationErrorList
        entity={data.entity}
        errors={data.validationErrors}
      />
    );
  }

  return (
    <SoftValidationWrapperStyled>
      <SoftValidationListStyled>{content}</SoftValidationListStyled>
    </SoftValidationWrapperStyled>
  );
};
